import { shippingLabelTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";
import {
  personalizedSlipBlockSchema,
  textSectionObjectSchema,
  type PersonalizedSlipBlock,
} from "../personalized-slip/personalized-slip-definition";
import {
  SHIPPING_LABEL_CUSTOM_SECTION_MAX_HEIGHT_INCHES,
  SHIPPING_LABEL_CUSTOM_SECTION_MIN_HEIGHT_INCHES,
} from "./shipping-label-layout";

const shippingLabelTextOptionsSchema = z.object({
  monospace: z.boolean().meta({ privacy: privacy.flag }).nullish(),
  padding: z
    .object({
      top: z.number().meta({ privacy: privacy.nonPii }),
      right: z.number().meta({ privacy: privacy.nonPii }),
      bottom: z.number().meta({ privacy: privacy.nonPii }),
      left: z.number().meta({ privacy: privacy.nonPii }),
    })
    .meta({ privacy: privacy.structured })
    .nullish(),
  singleLine: z.boolean().meta({ privacy: privacy.flag }).nullish(),
});
export type ShippingLabelTextOptions = z.infer<
  typeof shippingLabelTextOptionsSchema
>;

const shippingLabelTextBlockSchema = textSectionObjectSchema.extend(
  shippingLabelTextOptionsSchema.shape,
);
export type ShippingLabelTextBlock = z.infer<
  typeof shippingLabelTextBlockSchema
>;

const shippingLabelBlockSchema = z.union([
  shippingLabelTextBlockSchema,
  personalizedSlipBlockSchema,
]);
export type ShippingLabelBlock = ShippingLabelTextBlock | PersonalizedSlipBlock;

const shippingLabelTemplateSchema_ = z
  .object({
    id: shippingLabelTemplateIdFormat.schema.meta({
      privacy: privacy.id.internal,
    }),
    createdAt: z.string().meta({ privacy: privacy.timestamp }),
    updatedAt: z.string().meta({ privacy: privacy.timestamp }),
    name: z.string().meta({ privacy: privacy.resourceLabel }),
    blocks: z
      .array(shippingLabelBlockSchema)
      .meta({ privacy: privacy.structured }),
    customSectionHeightInches: z
      .number()
      .min(SHIPPING_LABEL_CUSTOM_SECTION_MIN_HEIGHT_INCHES)
      .max(SHIPPING_LABEL_CUSTOM_SECTION_MAX_HEIGHT_INCHES)
      .meta({ privacy: privacy.nonPii }),
  })
  .meta({ privacy: privacy.structured });

export interface ShippingLabelTemplate extends z.infer<
  typeof shippingLabelTemplateSchema_
> {}
export const shippingLabelTemplateSchema: z.ZodType<ShippingLabelTemplate> =
  shippingLabelTemplateSchema_;
